import React, { useState } from 'react';
import { ShieldCheck, Lock, Zap, CreditCard } from 'lucide-react';
export function PricingSection() {
  const [selected, setSelected] = useState<'completo' | 'basico'>('completo');
  const checkoutBasico = 'https://argentina.recursodigital.shop/cart/48789960720603:1';
  const checkoutCompleto = 'https://argentina.recursodigital.shop/cart/48789962490075:1';
  return <section id="oferta" className="bg-premium-gradient pt-6 pb-12 px-5 scroll-mt-10 relative" data-id="element-194">
      <div className="absolute inset-0 bg-radial-glow opacity-50 pointer-events-none" data-id="element-195" />
      <div className="max-w-xl mx-auto relative z-10" data-id="element-196">
        <div className="text-center mb-6" data-id="element-197">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-3" data-id="element-198">
            Elegí tu <span className="text-blue-400" data-id="element-199">Acceso:</span>
          </h2>
          <p className="text-sm text-gray-400 font-medium" data-id="element-200">
            Ambas opciones incluyen los 6 bonos estratégicos
          </p>
        </div>

        <button onClick={() => setSelected('basico')} className={`w-full text-left bg-white/5 backdrop-blur-sm rounded-xl p-5 mb-4 border-2 transition-all ${selected === 'basico' ? 'border-gray-400' : 'border-white/10'}`} data-id="element-201">
          <div className="flex items-start justify-between gap-4" data-id="element-202">
            <div className="flex items-start gap-3" data-id="element-203">
              <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 mt-0.5 flex items-center justify-center ${selected === 'basico' ? 'border-white' : 'border-gray-600'}`} data-id="element-204">
                {selected === 'basico' && <div className="w-2.5 h-2.5 rounded-full bg-white" data-id="element-205" />}
              </div>
              <div data-id="element-206">
                <div className="flex items-center gap-2 mb-1" data-id="element-207">
                  <span className="text-base" data-id="element-208">📘</span>
                  <h4 className="text-sm font-black text-white uppercase" data-id="element-209">
                    MEGAPACK HOGAR PREPARADO™
                  </h4>
                </div>
                <p className="text-xs text-gray-500" data-id="element-210">6 tomos + 6 bonos</p>
              </div>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-211">
              <div className="text-xs text-gray-600 line-through" data-id="element-212">
                $27.990 ARS
              </div>
              <div className="text-2xl font-black text-white" data-id="element-213">$19.990</div>
            </div>
          </div>
        </button>

        <button onClick={() => setSelected('completo')} className={`w-full text-left bg-white/5 backdrop-blur-sm rounded-xl p-5 relative border-2 transition-all ${selected === 'completo' ? 'border-brand-yellow' : 'border-white/10'}`} data-id="element-214">
          <div className="flex items-start justify-between gap-4" data-id="element-215">
            <div className="flex items-start gap-3" data-id="element-216">
              <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 mt-0.5 flex items-center justify-center ${selected === 'completo' ? 'border-brand-yellow' : 'border-gray-600'}`} data-id="element-217">
                {selected === 'completo' && <div className="w-2.5 h-2.5 rounded-full bg-brand-yellow" data-id="element-218" />}
              </div>
              <div data-id="element-219">
                <div className="flex items-center gap-2 mb-1.5" data-id="element-220">
                  <span className="text-base" data-id="element-221">🏆</span>
                  <h4 className="text-sm font-black text-white uppercase" data-id="element-222">
                    MEGAPACK + SISTEMA HOGAR PREPARADO™
                  </h4>
                </div>
                <div className="flex flex-wrap gap-2 mb-1" data-id="element-223">
                  <span className="bg-brand-yellow text-black text-[10px] font-black px-2 py-0.5 rounded-md" data-id="element-224">
                    ⭐ MÁS ELEGIDO
                  </span>
                  <span className="bg-green-600 text-white text-[10px] font-black px-2 py-0.5 rounded-md" data-id="element-225">
                    AHORRÁS $22.000
                  </span>
                </div>
                <p className="text-xs text-gray-400 leading-tight" data-id="element-226">
                  6 tomos + 6 bonos + Sistema completo
                </p>
                <p className="text-[10px] text-gray-500 mt-0.5 leading-tight" data-id="element-227">
                  (Sistema práctico para aplicar preparación real en el hogar)
                </p>
              </div>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-228">
              <div className="text-xs text-gray-600 line-through" data-id="element-229">
                $49.990 ARS
              </div>
              <div className="text-2xl font-black text-white" data-id="element-230">$27.990 </div>
            </div>
          </div>
        </button>

        <a href={selected === 'completo' ? checkoutCompleto : checkoutBasico} className="block w-full btn-premium md:text-xl py-5 px-6 rounded-xl transition-all hover:scale-[1.02] text-center mt-8 mb-6 text-[16px] font-black" data-id="element-231">
          {selected === 'completo' ? 'SÍ, QUIERO TODO EL SISTEMA →' : 'QUIERO MI MEGAPACK AHORA →'}
        </a>

        <p className="text-center text-xs text-gray-500 italic mb-6 max-w-sm mx-auto leading-relaxed" data-id="element-232">
          {selected === 'completo' ? 'La opción más elegida por personas que quieren preparación más completa, organización real y mayor tranquilidad.' : 'Incluye los 6 tomos completos y los 6 bonos estratégicos'}
        </p>

        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl py-3 px-4" data-id="element-233">
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] font-semibold text-gray-400" data-id="element-234">
            <div className="flex items-center gap-1.5" data-id="element-235">
              <Lock size={13} className="text-brand-yellow" data-id="element-236" />
              Pago seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-237">
              <Zap size={13} className="text-brand-yellow" data-id="element-238" />
              Acceso en 5 min
            </div>
            <div className="flex items-center gap-1.5" data-id="element-239">
              <ShieldCheck size={13} className="text-brand-yellow" data-id="element-240" />
              Garantía 7 días
            </div>
            <div className="flex items-center gap-1.5" data-id="element-241">
              Pagás en moneda local
            </div>
          </div>
          <div className="flex items-center justify-center gap-2 mt-2.5 pt-2.5 border-t border-gray-800" data-id="element-242">
            <CreditCard size={14} className="text-brand-yellow flex-shrink-0" data-id="element-243" />
            <span className="text-[11px] text-gray-400 font-medium text-center" data-id="element-244">
              Pagá con tarjeta o MercadoPago de forma segura y accedé al
              material HOY
            </span>
          </div>
        </div>
      </div>
    </section>;
}